export const portletConstants = {
    'Cards' : {
        'Resources' : {
            background: 'linear-gradient(91.58deg, #B11A75 1.94%, #6600E8 96.02%)'
        },
        'Write-Along': {
            background: 'linear-gradient(91.58deg, #1C3EF1 1.94%, #25B9F9 96.02%)'
        },
        'i-Express Experiences': {
            background: 'linear-gradient(91.58deg, #E86F00 1.94%, #FFE600 96.02%)'
        },
        'Scholar and Professionals': { 
            background: 'linear-gradient(91.58deg, #0C1777 1.94%, #2973E9 96.02%)' 
        }
    },
    'Title' : {
        'Resources' : {
             borderBottom: '5px solid #B11A75 '
        },
        'Write-Along': {
            borderBottom: '5px solid #1C3EF1'
        },
        'i-Express Experiences': {
            borderBottom: '5px solid  #E86F00  '
        },
        'Scholar and Professionals': { 
            borderBottom: '5px solid #0C1777 ' 
        }
    }
};